import { Pipe, PipeTransform } from '@angular/core';
import { AccountCompanyResponse, User } from 'src/app/shared';

@Pipe({ name: 'isCurrentCompany' })
export class IsCurrentCompanyPipe implements PipeTransform {
  transform(row: AccountCompanyResponse, loggedUser: User): boolean {
    return row.company.id === loggedUser.company.id;
  }
}
